import React, { ReactElement, useEffect } from 'react';
import { FormGroup, Label, Select } from 'idsk-react-components';
import PrispevokVestnika from '../../../../../model/PrispevokVestnika';
import { SafeParameterSetter } from '../../../../../model/types/SafeParameterSetter';
import { useUserContext } from '../../../../../context/UserContext';

interface Props {
  onUpdateField: SafeParameterSetter<PrispevokVestnika>;
}

const ImporterAutor = ({
  onUpdateField,
}: Props): ReactElement => {
  const { pouzivatel } = useUserContext();

  useEffect(() => {
    onUpdateField('vestnik', {
      uuid: pouzivatel.organizaciaCiselnikyUuid,
      skratenyNazov: pouzivatel.organizaciaSkratka,
      ldapUuid: pouzivatel.organizaciaUuid,
      nazov: pouzivatel.organizaciaNazov,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pouzivatel.organizaciaUuid]);

  return (
    <>
      <FormGroup className="priloha-vestnika-create-form-group__disabled">
        <Label htmlFor="vestnik">Autor príspevku</Label>
        <Select
          id="vestnik"
          width="three-quarters"
          name="vestnikUuid"
          disabled
        >
          <option key={pouzivatel.organizaciaCiselnikyUuid} value={pouzivatel.organizaciaCiselnikyUuid} hidden>
            {pouzivatel.organizaciaSkratka}
          </option>
        </Select>
      </FormGroup>
      <FormGroup className="priloha-vestnika-create-form-group__disabled">
        <Label htmlFor="vestnikDisabled">Vestník</Label>
        <Select
          id="vestnikDisabled"
          width="three-quarters"
          name="vestnikDisabled"
          disabled
        >
          <option key={pouzivatel.organizaciaCiselnikyUuid} value={pouzivatel.organizaciaCiselnikyUuid} hidden>
            {pouzivatel.organizaciaNazov}
          </option>
        </Select>
      </FormGroup>
    </>
  );
};
export default ImporterAutor;
